import {closeModal, fetchData, openModal, renderElements} from "./utils/common";
import {RESET_INPUT_VALUE, SearchInputStatus, VisibleStatus} from "./utils/consts";

export const taskSearch = () => {
  const taskSearchElement = document.querySelector(`.js-task-search`);

  if (taskSearchElement) {
    const changeTaskTypeElement = taskSearchElement.querySelector(`.js-task-radio-type`);
    const searchInputElement = taskSearchElement.querySelector(`.js-task-search-input`);
    const resetButtonElement = taskSearchElement.querySelector(`.js-task-search-reset`);
    const searchResultModal = taskSearchElement.querySelector(`.js-task-search-modal`);
    const searchResultList = searchResultModal.querySelector(`.js-task-search-list`);
    const hiddenInputElement = taskSearchElement.querySelector(`.js-task-search-h-input`);
    const projectNameElement = document.querySelector(`.js-task-change-project`);
    const createTaskForm = changeTaskTypeElement.form;
    const changeTaskName = changeTaskTypeElement.name;
    const taskValue = changeTaskTypeElement.value;
    let currentProjectId = projectNameElement.value;

    const setInputVisibleStatus = (status) => {
      switch (status) {
        case VisibleStatus.SHOW:
          searchInputElement.classList.add(`selection__search-input--active`);
          break;
        case VisibleStatus.HIDE:
          searchInputElement.classList.remove(`selection__search-input--active`);
          break;
      }
    };

    const setResetButtonVisibleStatus = (status) => {
      switch (status) {
        case VisibleStatus.SHOW:
          resetButtonElement.classList.remove(`selection__search-btn--hide`);
          break;
        case VisibleStatus.HIDE:
          resetButtonElement.classList.add(`selection__search-btn--hide`);
          break;
      }
    };

    const setSelectVisibleStatus = (status) => {
      switch (status) {
        case VisibleStatus.SHOW:
          openModal(searchResultModal, `flex`);
          break;
        case VisibleStatus.HIDE:
          closeModal(searchResultModal);
          break;
      }
    };

    const filterItems = (value) => {
      Array.from(searchResultList.children).forEach((item) => {
        if (!value.length) {
          item.classList.remove(`modal__item--hide`);
          return;
        }

        if (item.textContent.trim().toLowerCase().includes(value.trim().toLowerCase())) {
          item.classList.remove(`modal__item--hide`);
        } else {
          item.classList.add(`modal__item--hide`);
        }
      });
    };

    const activateSearchInput = (status) => {
      switch (status) {
        case SearchInputStatus.ACTIVATE:
          setInputVisibleStatus(VisibleStatus.SHOW);
          setResetButtonVisibleStatus(VisibleStatus.SHOW);

          searchInputElement.disabled = null;
          hiddenInputElement.disabled = null;

          searchInputElement.addEventListener(`input`, onSearchFieldInput);
          searchInputElement.addEventListener(`focus`, onSearchFieldFocus);
          searchInputElement.addEventListener(`blur`, onSearchFieldBlur);
          searchResultModal.addEventListener(`click`, onSearchResultSelectClick);
          break;

        case SearchInputStatus.DISABLED:
          searchInputElement.disabled = `disabled`;
          hiddenInputElement.disabled = `disabled`;

          setInputVisibleStatus(VisibleStatus.HIDE);
          setSelectVisibleStatus(VisibleStatus.HIDE);
          setResetButtonVisibleStatus(VisibleStatus.HIDE);

          searchInputElement.removeEventListener(`input`, onSearchFieldInput);
          searchInputElement.removeEventListener(`focus`, onSearchFieldFocus);
          searchInputElement.removeEventListener(`blur`, onSearchFieldBlur);
          searchResultModal.removeEventListener(`click`, onSearchResultSelectClick);
          break;
      }
    };

    const setHiddenInputValue = (value) => (hiddenInputElement.value = value);
    const setSearchResultInputValue = (value) => (searchInputElement.value = value);

    const resetSearchFields = () => {
      setSearchResultInputValue(RESET_INPUT_VALUE);
      setHiddenInputValue(RESET_INPUT_VALUE);
    };

    const onSearchResultSelectClick = (evt) => {
      if (evt.target.classList.contains(`js-task-search-item`)) {
        setSearchResultInputValue(evt.target.textContent.trim());
        setHiddenInputValue(evt.target.dataset.value);
      }
    };

    const onCreateTaskFormChange = () => {
      if (createTaskForm[changeTaskName].value === taskValue) {
        activateSearchInput(SearchInputStatus.DISABLED);
      } else {
        activateSearchInput(SearchInputStatus.ACTIVATE);
      }
    };

    const onSearchFieldFocus = () => {
      setSelectVisibleStatus(VisibleStatus.SHOW);
    };

    const onSearchFieldBlur = () => {
      setSelectVisibleStatus(VisibleStatus.HIDE);
    };

    const onSearchFieldInput = (evt) => {
      const self = evt.currentTarget;
      filterItems(self.value);
    };

    const onProjectInputChange = async (evt) => {
      const self = evt.currentTarget;
      const projectId = self.value;

      if (currentProjectId !== projectId) {
        resetSearchFields();
      }
    };

    const onResetButtonElementClick = () => {
      resetSearchFields();
    };

    const onWindowDOMContentLoaded = () => {
      if (createTaskForm[changeTaskName].value !== taskValue) {
        activateSearchInput(SearchInputStatus.ACTIVATE);
      }
    };

    window.addEventListener(`DOMContentLoaded`, onWindowDOMContentLoaded);
    projectNameElement.addEventListener(`change`, onProjectInputChange);
    createTaskForm.addEventListener(`change`, onCreateTaskFormChange);
    resetButtonElement.addEventListener(`click`, onResetButtonElementClick);
  }
};
